import React, { useEffect, useState } from "react";
import styles from "./selectFieldComponent.module.scss";
import { Spinner } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";

const SelectFieldComponent = ({
  optionsList,
  firstOption,
  onSelectChange,
  classes,
}) => {
  const [selectedValue, setSelectedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [firstOption]);

  const handleSelectChange = async (event) => {
    setIsLoading(true);
    const value = event.target.value;
    onSelectChange(value);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsLoading(false);
  };

  if (isLoading) {
    return <ClipLoader color="#fff" size="22px" />;
  }

  return (
    <div className="w-100">
      {isLoading && <ClipLoader color="#fff" size="22px" />}
      <select
        className={`${classes} ${styles.select}`}
        onChange={handleSelectChange}
        defaultValue={firstOption}
      >
        <option value="" hidden className="text-grey">
          {firstOption}
        </option>
        {optionsList.map((dt, index) => (
          // console.log(dt)
          <option value={dt?.value} key={index}>
            {dt?.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectFieldComponent;
